import React from "react";
import { GoogleAnalyticsEnum, triggerFunction } from "../../../utils/google-analytics";
import { toUpperSnake } from "../../../utils";
import { useInterviewContext } from "../../../context/interview_context";


function InterviewQuestionCategory({ currentCategory, classes }) {

  // Extracting variables from context
  const { interviewCategories, interviewSeries } = useInterviewContext();

  // Const variable
  const categories = interviewCategories && interviewCategories?.length ? interviewCategories : [];
  const series = interviewSeries && interviewSeries?.length ? interviewSeries : [];
  const isPublishedSeries = series?.filter(i => i?.published === true);


  const data = categories?.map(category => {
    return {
      ...category,
      series: isPublishedSeries?.filter(item => item?.categoryId === category?.slug)
    };
  });

  const handleClick = (elm) => {
    try {
      triggerFunction(
        GoogleAnalyticsEnum.BUTTON,
        GoogleAnalyticsEnum.INTERVIEW_QUESTION_CATEGORY + `_DETAILED_${toUpperSnake(elm?.name)} `
      )
    } catch (error) {
      console.log("29: InterviewQuestionCategory :handleClick", error);
    }
  };

  return (
    <div>
      <div class={`edu-blog-widget-2 widget-categories ${classes ? classes : ""}`}>
        <div class="inner">
          <h5 class="widget-title">Categories</h5>
          <div class="content">
            <ul class="category-list">
              {data?.slice(0, 4).map((elm, i) => (
                <li key={i} className="fs-15">
                  <a href={`/interview-questions/${elm?.slug}`} onClick={() => handleClick(elm)}>
                    {elm?.name}<span>({elm?.series?.length})</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InterviewQuestionCategory;
